export const NewsLetterHeaderSVG = (props) => (
  <svg height={62} viewBox="0 0 82 62" width={82} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#1d1d1b"
      strokeWidth={1.5}
      transform="translate(1 1)"
    >
      <path
        d="m79.5547571 55.7212227c-1.0108939-4.1910137-3.9261998-6.4799681-3.9261998-6.4799681l-3.7575868-1.684823-23.6235982-25.0883095-3.1176416 2.2262147-.0154235 2.557428"
        strokeLinecap="round"
      />
      <path
        d="m22.6667651 31.8780354 4.2744053-6.438403 5.5404407-4.1578139.2086095.0933253 1.5896679 3.0695411 6.9912968 3.134895s5.3906495-.1905719 8.4481655-1.326161l3.6216507 1.6239133"
        strokeLinecap="round"
      />
      <path
        d="m69.487959 52.871689 2.383064-5.315362"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m68.953499 51.465403-22.351711-24.434534"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m21.8123023 31.4950878 47.6756566 21.3764704 10.5120411 2.9756929-1.2438151 3.7066108-11.0542169-2.6988539-47.6759179-21.3767318z"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <g strokeLinejoin="round">
        <path d="m53.076998 30.857391 2.23824-.883585" />
        <path d="m55.045535 32.994149 2.295229-.868945" />
        <path d="m57.032947 35.181465 2.410251-.82372" />
        <path d="m59.039782 37.419051 2.39901-.942141" />
        <path d="m61.217138 39.649527 2.281373-.985014" />
        <path d="m63.119537 41.840163 2.442928-.983707" />
        <path d="m65.094949 44.147442 2.46724-1.02684" />
        <path d="m67.230191 46.19179 2.470116-.940834" />
      </g>
      <path
        d="m48.8177429 30.1337298-8.0169271.7943-9.1880114-4.0988822-1.9436391-3.8102276-4.0178668-11.8018607-14.3207654-7.62000115-11.3305331 1.86075571 2.04060959 6.85640644 9.57538931-1.097161"
        strokeLinecap="square"
      />
      <path
        d="m3.61074967 12.1345232 1.62600457 6.3189361 9.66714616-1.1426472"
        strokeLinecap="square"
      />
      <path
        d="m7.54960196 18.1799926 1.43177284 6.2878276 11.3613802-1.2981895 5.8821107 3.3484715"
        strokeLinecap="round"
      />
      <path
        d="m30.7494456 22.5814458-2.6924387-14.06402983-14.0039831-8.51741597-6.50342184 1.23754244.8106284 2.76830336"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
